'use client';

import { useEffect } from 'react';
import { initClientMockData } from '@/lib/mockApi';

/**
 * Client-side bootstrap component that initializes mock data
 * Runs once when the app loads in the browser
 */
export function ClientBootstrap() {
  useEffect(() => {
    initClientMockData();
  }, []);

  return null;
}

